<template>
  <div
    v-select-test-parts
    :data-testid="selectTestId('select')"
  >
    <v-select
      ref="groupselect"
      :label="$t('Group')"
      :items="groups"
      :item-text="(item) => $t(item.groupName)"
      item-value="groupId"
      :value="selectedGroup"
      :readonly="readonly"
      :disabled="readonly"
    >
      <template #selection="{ item }">
        <v-icon
          small
          class="mr-2"
        >
          {{ icon(item.groupId) }}
        </v-icon>
        {{ $t(item.groupName) }}
      </template>
      <template #item="{ item }">
        <div :data-testid="selectTestId('option', item.groupId)">
          <v-icon
            small
            class="mr-2"
          >
            {{ icon(item.groupId) }}
          </v-icon>
          {{ $t(item.groupName) }}
        </div>
      </template>
    </v-select>
  </div>
</template>
<script>

import { userGroupIcon } from '../../../util/tools'
import { testIdFor, selectTestParts } from '../../../util/testId'
export default {
  name: 'HdGroupSelector',
  directives: { selectTestParts },
  props: {
    selectedGroup: {
      type: Number,
      required: false,
      default() {
        return 0
      }
    },
    readonly: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    /**
     * Base data-testid: the select gets '<testId>-select', options '<testId>-option-<groupId>'
     */
    testId: {
      type: String,
      required: false,
      default: null,
    },
  },
 
  computed: {
    groups() { 
      return [...this.$store.state.user.groups].sort((a, b) => a.groupValue - b.groupValue)
    }
  },

  methods: {
    selectTestId(...parts) {
      return testIdFor(this.testId, ...parts)
    },
    icon(gid) {
      return userGroupIcon(gid)
    }, 
    /**
     * Returns selection value
     */
    getValue() {       
      return this.$refs.groupselect.internalValue
    },
  }
}
</script>
